import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper :
 * - Wrapper for RectangleNode
 */
export function Wrapper(props) {
  return (
    <div
      className={props.className}
      tabIndex={props.tabIndex}
      onClick={props.onClick}
      onKeyDown={(e)=>{
        if(e.keyCode === 13){
          props.onClick();
        }
      }}
    >
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
  /**
   * Child components
   */
  children: PropTypes.array,
  /**
   * function to invoke on click
   */
  onClick: PropTypes.func,
};

Wrapper.defaultProps = {
  className: '',
};
